export default class SendTestPushNotificationRequest {
    title = '';
    body = '';
}